import { customElement } from "lit/decorators.js";

import { Wizard } from "../wizard/wizard";
import { NOTARY_ESTIMATION_WIZARD_CONFIGURATION } from "./notary-estimation-wizard-configuration";

@customElement("oz-notary-estimation-wizard")
export class NotaryEstimationWizard extends Wizard<NotaryEstimationWizard> {
	constructor() {
		super(NOTARY_ESTIMATION_WIZARD_CONFIGURATION);
	}
}
